import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "./Auth";

function PrivateRoute({ component: Component, ...rest }) {
    const auth = useAuth();

    return (
        <Route
            {...rest}
            render={props =>
                auth.user["id"] ? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/login" />
                )
            }
        />
    );
}

export default PrivateRoute;